/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import {
  Box, Grid,
  Typography
} from '@mui/material';
import './Find.css';
import FindDropdown from '../../components/find/FindDropdown';
import FindCreateForm from '../../components/find/FindCreateForm';
import { useSelector } from 'react-redux';
import { NOTE } from '../../utils/GlobalConstants';
import DialogView from '../../components/common/dialog/DialogView';
import Typo from '../../components/common/typo/Typo';
import ButtonView from '../../components/common/button/ButtonView';
import { getRequest } from '../../services/RequestConfig';
import {  addFindehicle, fetchAllVehicleDetails } from '../../services/SurveyRequest';
import { useTranslation } from 'react-i18next';

const Find = ({ handleChangeForTab }) => {
 
  const [isPopup, setPopup] = useState(false)
  const [selectedRows, setSelectedRows] = useState([])
  const[selectedKey, setSelectedKey]= useState([])
  const [dataLoading, setDataLoading] = useState(false)
  const [filteredData, setFilteredData] = useState([])
   const [filteredDefaultData, setFilteredDefaultData] = useState([])
  const [showMssg, setShowMssg] = useState('')
const [filters, setFilters] = useState({});
const [options, setOptions] = useState({});
const { t } = useTranslation();
const [filterKeys, setFilterKeys] = useState([
  { key: 'type', label: `${t("tab3.contents.VehicleType")}`, api: 'fleet/vehicle-types', required: true, disabled: false },
  { key: 'year', label: `${t("tab3.contents.ModelYear")}`, api: 'fleet/vehicle-years', disabled: true },
  { key: 'make', label:`${t("tab3.contents.Make")}`, api: 'fleet/vehicle-makes', required: true, disabled: true },
  { key: 'model', label: `${t("tab3.contents.Model")}`, api: 'fleet/vehicle-models', disabled: true },
  
  { key: 'engines', label:`${t("tab3.contents.Engine")}`, api: 'fleet/vehicle-engines', disabled: true },
]);
  const [isAdd, setIsAdd] = useState(false)
  const selectedSurvey = useSelector(
    (state) => state?.SurveyPageData?.selectedSurvey
  );

useEffect(() => {
  const fetchVehicleTypeData = async () => {
    try {
      const res = await getRequest('fleet/vehicle-types');
      const response = res.vehicleTypes?.map(item => ({
        id: item?.typeId,
        label: item?.type
      })) || [];
      setOptions({ type: response });
    } catch (err) {
      console.error('Error fetching vehicle types', err);
      setOptions({ type: [] });
    }
  };
  fetchVehicleTypeData();
}, []);
 

useEffect(() => {
  const fetchVehicleTypeData = async () => {
    try {
      const res = await getRequest('fleet/vehicle-types');
      const response = res.vehicleTypes?.map(item => ({
        id: item?.typeId,
        label: item?.type
      })) || [];
      setOptions({ type: response });
    } catch (err) {
      console.error('Error fetching vehicle types', err);
      setOptions({ type: [] });
    }
  };
  fetchVehicleTypeData();
}, []);

const uniqueItem=(data=[])=>{
  const uniquemodelOpt = Array.from(
  new Map(data?.map(item => [item.label, item])).values()
);

return uniquemodelOpt
}

const handleChange = (key) => async (_, value) => {
  setSelectedKey([]);
  setSelectedRows([]);
  const upFilter = { ...filters, [key]: value || '' };
  setFilters(upFilter);
  const resetBelowItem = (startKey, excludeKeys = []) => {
    const keyRev = filterKeys
      .slice(filterKeys.findIndex(f => f.key === startKey) + 1)
      .map(f => f.key)
      .filter(k => !excludeKeys.includes(k));
    setFilters(prev => {
      const newData = { ...prev };
      keyRev.forEach(k => newData[k] = '');
      return newData;
    });
    setFilterKeys(prev =>
      prev.map(item =>
        keyRev.includes(item.key)
          ? { ...item, disabled: true }
          : item
      )
    );
  };
  const buildQuery = (params) =>
    Object.entries(params)
      .filter(([_, v]) => v !== undefined && v !== null && v !== '')
      .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
      .join('&');
  try {
    switch (key) {
      case 'type':
        resetBelowItem('type');
        if (value) {
          const typeObj = options?.type?.find(item => item.label === value);
          if (!typeObj) return;
          const yearQuery = buildQuery({ type: typeObj.label, typeId: typeObj.id });
          const resYear = await getRequest(`fleet/vehicle-years?${yearQuery}`);
          const yearOpt = [
  { id: 'unknown', label: "I don't know" },
  ...(
    resYear?.vehicleYear
      ?.sort((a, b) => b - a) 
      .map((item, index) => ({ id: index + 1, label: item })) || []
  )
];
          setOptions(prev => ({ ...prev, year: uniqueItem(yearOpt) }));
          setFilterKeys(prev => prev.map(item => item.key === 'year' ? { ...item, disabled: false } : item));
          const makeQuery = buildQuery({ typeId: typeObj.id, type: typeObj.label });
          const resMake = await getRequest(`fleet/vehicle-makes?${makeQuery}`);
          const makeOpts = resMake?.vehicleMake?.map(item => ({ id: item?.makeId, label: item?.make })) || [];
          setOptions(prev => ({ ...prev, make: uniqueItem(makeOpts) }));
          setFilterKeys(prev => prev.map(item => item.key === 'make' ? { ...item, disabled: false } : item));
        }
        break;
      case 'year':
        resetBelowItem('year');
        const typeObjs = options?.type?.find(item => item.label === filters.type);
        if (!typeObjs) return;
        const makeParams = {
          typeId: typeObjs.id,
          type: typeObjs.label,
          year: value !== "I don't know" ? value : undefined
        };
        const makeUrl = buildQuery(makeParams);
        const resMakeYear = await getRequest(`fleet/vehicle-makes?${makeUrl}`);
        const makeOptsYear = resMakeYear?.vehicleMake?.map(item => ({ id: item?.makeId, label: item?.make })) || [];
        setOptions(prev => ({ ...prev, make: uniqueItem(makeOptsYear) }));
        setFilterKeys(prev => prev.map(item => item.key === 'make' ? { ...item, disabled: false } : item));
        break;
      case 'make':
        resetBelowItem('make');
        if (value) {
          const makeObj = options?.make?.find(item => item.label === value);
          const typeObj = options?.type?.find(item => item.label === filters.type);
          if (!makeObj || !typeObj) return;
          const modelParams = {
            type: typeObj.label,
            typeId: typeObj.id,
            make: value,
            makeId: makeObj.id,
            year: filters?.year !== "I don't know" ? filters?.year : undefined
          };
          console.log("Model API Params:", modelParams);
          const modelQuery = buildQuery(modelParams);
          const resModel = await getRequest(`fleet/vehicle-models?${modelQuery}`);
          if (!resModel?.vehicleModel) {
            console.error("Invalid model data");
            setOptions(prev => ({ ...prev, model: [] }));
            return;
          }
          const modelOpt = [
            { id: 'unknown', label: "I don't know" },
            ...(resModel.vehicleModel.map(item => ({ id: item?.modelId, label: item?.model })) || [])
          ];
          setOptions(prev => ({ ...prev, model: uniqueItem(modelOpt) }));
          setFilterKeys(prev => prev.map(item => item.key === 'model' ? { ...item, disabled: false } : item));
          const engineParams = {
            type: typeObj.label,
            typeId: typeObj.id,
            make: value,
            makeId: makeObj.id,
            model: filters.model !== "I don't know" ? filters.model : undefined,
            year: filters.year !== "I don't know" ? filters.year : undefined
          };
          const engineQuery = buildQuery(engineParams);
          const resEngine = await getRequest(`fleet/vehicle-engines?${engineQuery}`);
          const engineOptions = resEngine?.vehicleEngines?.map(item => ({ id: item?.engineId, label: item?.engineName })) || [];
          setOptions(prev => ({ ...prev, engines: uniqueItem(engineOptions) }));
          setFilterKeys(prev => prev.map(item => item.key === 'engines' ? { ...item, disabled: false } : item));
        }
        break;
      case 'model':
  resetBelowItem('model', ['make']);
  setFilterKeys(prev =>
    prev.map(item =>
      item.key === 'engines' ? { ...item, disabled: false } : item
    )
  );
  const typeObj = options?.type?.find(item => item.label === filters.type);
  const makeObj = options?.make?.find(item => item.label === filters.make);
  const modelObj = options?.model?.find(item => item.label === value);
  if (typeObj && makeObj) {
    const engineParams = {
      type: typeObj.label,
      typeId: typeObj.id,
      make: filters.make,
      makeId: makeObj.id,
      model: value !== "I don't know" ? value : undefined,
      modelId: value !== "I don't know" ? modelObj?.id : undefined,
      year: filters.year !== "I don't know" ? filters.year : undefined
    };
    try {
      const engineQuery = buildQuery(engineParams);
      const resEngine = await getRequest(`fleet/vehicle-engines?${engineQuery}`);
      const engineOptions = resEngine?.vehicleEngines?.map(item => ({
        id: item?.engineId,
        label: item?.engineName
      })) || [];
      setOptions(prev => ({ ...prev, engines: uniqueItem(engineOptions) }));
    } catch (error) {
      console.error("Error fetching engines:", error);
      setOptions(prev => ({ ...prev, engines: [] }));
    }
  }
  break;
  case 'engines':
      resetBelowItem('engines');
      if (value) {
        const filtered = filteredDefaultData?.map(vehicle => {
          const matchEng = vehicle.engines.find(engine => engine.engineName === value);
          return {
            ...vehicle,
            engines: matchEng ? [matchEng] : []
          };
        });
        setFilteredData(filtered?.filter(item => item?.engines?.length > 0));
      }
      break;

      default:
        break;
    }
  } catch (error) {
    console.error(`Error handling ${key} change:`, error);
    setOptions(prev => ({ ...prev, [key]: [] }));
  }
};
 


  const getVehicleDetails = async () => {
  if (filters?.type?.length > 0 && filters?.make?.length > 0) {
    setDataLoading(true);
    const makeObj = options?.make?.find(item => item?.label === filters.make);
    const makeId = makeObj?.id;
    const baseUrl = `fleet/vehicle-details?`;
    try {
      const queryParam = Object.entries({ ...filters, makeId })
        .filter(([key, value]) => {
          return value !== undefined && value !== null && value !== '' && value !== "I don't know";
        })
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
      const finalUrl = baseUrl + queryParam;
      const response = await fetchAllVehicleDetails(finalUrl);
      const vehicles = response?.vehicles?.map((item, index) => ({ ...item, id: index + 1 })) || [];
      setFilteredData(vehicles);
      setFilteredDefaultData(vehicles);
      setDataLoading(false);
      return response;
    } catch (e) {
      setDataLoading(false);
      return [];
    }
  }else{
     setFilteredData([]);
      setFilteredDefaultData([]);
      setDataLoading(false);
      return []
  }
};
 
  useEffect(() => {
    if(filters && filters?.engines===''){
    getVehicleDetails()
    }
   if(filters && Object.values(filters)?.every(val=>val==='')){
    setFilteredData([])
   }
  }, [filters]);
  useEffect(() => {

    if (!selectedSurvey?.surveyName) {
      setPopup(true)
    }
  }, [])


  useEffect(() => {
    if (showMssg?.success) {
      const timer = setTimeout(() => {
        setShowMssg();
        setSelectedRows([])
        setSelectedKey([])
         onClickHomepage();
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [showMssg]);
  const onClickHomepage = () => {
    handleChangeForTab("", 0);
  }
  const addVehicleSurvey = async () => {
  try {
    setIsAdd(true);
    const payload = {
      surveyId: selectedSurvey?.id,
      vehicles: filteredData?.filter(item =>
        selectedRows?.includes(item?.vehicleId) &&
        selectedKey?.includes(item?.id)
      )
    };
    const response = await addFindehicle(payload);
    setShowMssg({ success: true, text: response?.data.message });
    await getVehicleDetails(); // Refresh Make/Model after adding
    setIsAdd(false);
  } catch (e) {
    console.error("Error adding vehicle:", e);
    setShowMssg({ success: false, text: 'Something Went Wrong' });
    setIsAdd(false);
  }
};
 
  return (
    <> {isPopup ?
      <DialogView
        open={isPopup}
        testid={'vin_status'}
        handleClose={(e) => onClickHomepage(e)}
        width={"33%"}
        maxWidth={"75em!important"}
        heading={NOTE}
        childComponet={
          <div>
            <div><Typography>Please select a survey to proceed</Typography></div>
            <div className='flx-end' onClick={(e) => onClickHomepage(e)}><ButtonView label='Okay'></ButtonView></div>
          </div>
        }
      /> : <Box component="fieldset" className="fieldset-style" sx={{ p: 3, borderRadius: 2, borderColor: 'primary.main' }}>
        <Grid container spacing={0}>
          <Grid item xs={12} mt={2} md={2} sx={{ pr: 2 }}>
            <FindDropdown filterKeys={filterKeys} options={options}
              handleChange={handleChange} filters={filters} />
          </Grid>
          <Grid item md={0.1} sx={{ borderRight: '1px solid #ccc', height: '100%' }} />
          <Grid item xs={12} md={9.9} sx={{ pl: 2 }} mt={2}>
            <div className="surveyDisplay surveyDb">
              <Typo text={'Selected Survey:'} />
              <Typo className="surveyName" text={selectedSurvey?.surveyName} />
            </div>
            <FindCreateForm dataLoading={dataLoading} filteredData={filteredData} filterKeys={filterKeys} selectedRows={selectedRows}
              setSelectedRows={setSelectedRows} selectedKey={selectedKey} setSelectedKey={setSelectedKey}/>
          </Grid>
          <Grid item xs={12} mt={2}>
            <div className='d-flexend'>
              <div className={showMssg?.success ? 'mssg-green' : 'mssg-red'}>{showMssg?.text}</div>
              <ButtonView
                data-testid="button"
                testid="import-upload-btn"
                label={isAdd ? 'Loading' : 'Add To Survey'}
                variant="contained"
                color="primary"
                disabled={selectedRows?.length <= 0}
                onClick={() => {
                  addVehicleSurvey()
                }}
              ></ButtonView>
            </div>

          </Grid>
        </Grid>
      </Box>}</>

  );
};
export default Find;
